import {
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
} from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { RideAddPassengerViewStationsEnum } from "@ryde/shared";

interface IRideAddPassengerViewSwitch {
  name: string;
  stationsDisplayOptions: RideAddPassengerViewStationsEnum[];
}

export const RideAddPassengerViewSwitch: FC<IRideAddPassengerViewSwitch> = ({
  name,
  stationsDisplayOptions,
}) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <div className="add-passenger-view-switch">
      <h3>{t("ride.DisplayStationsTitle")}</h3>
      <div className="view-options-container">
        <Controller
          rules={{ required: true }}
          control={control}
          name={name}
          render={({ field, fieldState: { error } }) => (
            <>
              <RadioGroup {...field}>
                {stationsDisplayOptions?.includes(
                  RideAddPassengerViewStationsEnum.DisplayRideStations,
                ) && (
                  <FormControlLabel
                    value={RideAddPassengerViewStationsEnum.DisplayRideStations}
                    control={
                      <Radio size="small" onClick={e => e.stopPropagation()} />
                    }
                    label={t(
                      `ride.${RideAddPassengerViewStationsEnum.DisplayRideStations}`,
                    )}
                    onClick={e => e.preventDefault()}
                  />
                )}
                {stationsDisplayOptions?.includes(
                  RideAddPassengerViewStationsEnum.DisplayRideAndCourseStations,
                ) && (
                  <FormControlLabel
                    value={
                      RideAddPassengerViewStationsEnum.DisplayRideAndCourseStations
                    }
                    control={
                      <Radio size="small" onClick={e => e.stopPropagation()} />
                    }
                    label={t(
                      `ride.${RideAddPassengerViewStationsEnum.DisplayRideAndCourseStations}`,
                    )}
                    onClick={e => e.preventDefault()}
                  />
                )}
                {stationsDisplayOptions?.includes(
                  RideAddPassengerViewStationsEnum.DisplayAllStations,
                ) && (
                  <FormControlLabel
                    value={RideAddPassengerViewStationsEnum.DisplayAllStations}
                    control={
                      <Radio size="small" onClick={e => e.stopPropagation()} />
                    }
                    label={t(
                      `ride.${RideAddPassengerViewStationsEnum.DisplayAllStations}`,
                    )}
                    onClick={e => e.preventDefault()}
                  />
                )}
              </RadioGroup>
              {error && <FormHelperText>{error.message}</FormHelperText>}
            </>
          )}
        />
      </div>
    </div>
  );
};
